import { HTMLAttributes, MouseEvent, useEffect } from 'react';

import { XCircle } from 'lucide-react';
import clsx from 'clsx';

import { Button } from './button';

type OverlayProps = HTMLAttributes<HTMLDivElement> & {
  open: boolean;
  allowScroll?: boolean;
  onClose: () => void;
};

export function Overlay(props: OverlayProps) {
  const { open, onClose, className = '', children, allowScroll = false, ...rest } = props;

  useEffect(() => {
    // block scroll when overlay is open
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return <></>;

  const handleOverlayClick = (e: MouseEvent<HTMLDivElement>) => {
    if ((e.target as HTMLDivElement).classList?.contains('modal-overlay')) {
      onClose();
    }
  };

  return (
    <div
      {...rest}
      className={clsx(
        className,
        'fixed top-0 left-0 right-0 bottom-0 bg-foreground/60 backdrop-blur-sm dark:bg-card-foreground/20 dark:backdrop-blur-xl z-40',
        { 'max-h-screen overflow-auto': allowScroll }
      )}
      onClick={handleOverlayClick}
    >
      <div className="fixed top-0 right-0 flex justify-end m-6 z-50 text-accent-foreground">
        <Button onClick={onClose} variant="ghost-secondary" size="icon">
          <XCircle className="!size-6" />
        </Button>
      </div>
      <div className="relative max-w-[90vw] m-auto">{children}</div>
    </div>
  );
}
